// /signin inside the desktop app when the app could not make the session
// again: no sign-in here (a passkey or Google never comes back to the app),
// the way back in the app's settings instead.
import { m } from "@trameria/cloud-i18n";
import { SignedOutPage } from "./signed-out-page";

export function SignInInAppPage() {
  return (
    <SignedOutPage title={m.web_signin_in_app_title()}>
      <p className="text-[13px] leading-[1.7]">{m.web_signin_in_app_body()}</p>
    </SignedOutPage>
  );
}
